// extracted by css-extract-rspack-plugin
export default {"iconButton":"ChartSettingIconRadio-module__iconButton___pf1Cg"};